import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { TipoArquivoMultiselectComponent } from './tipo-arquivo-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        TipoArquivoMultiselectComponent
    ],
    exports: [
        TipoArquivoMultiselectComponent
    ]
})
export class TipoArquivoMultiselectModule { }
